module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    ref: "toolbox",
    class: [
      'toolbox',
      'toolbox--' + _vm.toolboxClass, _vm.show ? 'show' : '',
      _vm.ready ? '' : 'positioning',
      _vm.hasInput ? 'toolbox--has-input' : '',
      _vm.os === 'ios' ? 'ios' : '',
      _vm.tiny && _vm.hasInput ? 'toolbox--tiny' : ''
    ],
    style: (_vm.coordinates),
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [(!(_vm.tiny && _vm.hasInput)) ? _c('span', {
    staticClass: "toolbox-arrow",
    class: _vm.posArrow,
    style: (_vm.arrowCoordinates)
  }) : _vm._e(), _vm._v(" "), (!(_vm.tiny && _vm.hasInput)) ? _c(_vm.type, {
    tag: "component",
    attrs: {
      "payload": _vm.payload,
      "replacement": _vm.replacement
    }
  }) : _c('div', {
    staticClass: "toolbox-tiny"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('common.device.rotate')))]), _vm._v(" "), _c('action', {
    attrs: {
      "color": "blue"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close.apply(null, arguments)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5bb146a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/global/Toolbox.vue
// module id = 613
// module chunks = 225